import { CpnetAchComponent } from "./CpnetAchComponent";

export function CpnetAchScreen() {
  return (
    <>
      <CpnetAchComponent />
    </>
  );
}
